export default __webpack_public_path__ + "static/media/how-to.21ea8243.png";